module.exports = __webpack_public_path__ + "static/media/Group5702x.86b42953.png";